import { Component, Input, Output, EventEmitter, forwardRef, ViewChild, ElementRef } from '@angular/core';
import { HttpEventType, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { DocumentoService } from '../../_services/documento.service';
import { Utils } from '../../utils';
import { ExaDocumento, ExaDocumentoStato } from './exa-document';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { findNode } from '@angular/compiler';

import { FileService } from '../../_services/file.service';
import { AlertService } from '../_services/alert.service';
import { ExaFormControl, ExaControlStato } from '../exa-form-control';


@Component({
    selector: 'exa-file',
    templateUrl: './exa-file.component.html',
    styleUrls: ['./exa-file.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ExaFileComponent),
            multi: true
        }
    ]
})
export class ExaFileComponent extends ExaFormControl implements ControlValueAccessor {

    @Input() inModifica: boolean = false;
    @Input() canDelete: boolean = true;
    @Input() showName: boolean = false;
    @Input() uploadType: ExaFileUploadType = ExaFileUploadType.external;
    @Input() canUpload = true;
    @Input() canDownload = true;
    

    @Output() downloadFile = new EventEmitter();
    @Output() removeFile = new EventEmitter<ExaDocumento>();
    @Output() uploadFinished = new EventEmitter<ExaDocumento>();
    @Output() uploadStarted = new EventEmitter();
    @Output() uploadError = new EventEmitter<any>();
    @Output() fileSelected = new EventEmitter<any>();

    @ViewChild("inputField") inputField: any;

    private downloadAlive: boolean;
    private disabled: boolean;

    private exaDocumento: ExaDocumento;

    private temporaneo: boolean = false;

    private errorMessage: string = "";

    selectedFiles: FileList;
    currentFileUpload: File;
    progress: { percentage: number } = { percentage: 0 };

    constructor(
        private documentoService: DocumentoService,
        private fileService: FileService,
        private alertService: AlertService
    ) {
        super();
        this.exaDocumento = null;
    }

    download() {
        if (this.exaDocumento && this.exaDocumento.idDocumento > 0)
            this.documentoService.downloadDocumento(this.exaDocumento.idDocumento, this.exaDocumento.nomeFileDocumento);
    }

    remove() {
        let fd = new ExaDocumento();
        this.exaDocumento = fd;
        this.onChange(fd);
        this.removeFile.emit(this.exaDocumento);
    }

    getIconClass() {
        let ext = Utils.getFilenameExtension(this.exaDocumento.nomeFileDocumento).toLowerCase();

        if (ext == 'txt')
            return 'fa-file-text-o';
        if (ext == 'pdf')
            return 'fa-file-pdf-o';
        if ((ext == 'xls') || (ext == 'xlsx'))
            return 'fa-file-excel-o';
        if ((ext == 'doc') || (ext == 'docx'))
            return 'fa-file-word-o';
        if ((ext == 'jpg') || (ext == 'jpeg') || (ext == 'gif') || (ext == 'png'))
            return 'fa-image';

        return 'fa-file-o';
    }

    isFilePresente(): boolean {
        return this.exaDocumento && this.exaDocumento.idDocumento > 0 && (this.exaDocumento.stato == ExaDocumentoStato.caricato || this.exaDocumento.stato == ExaDocumentoStato.temporaneo);
    }

    isFileScaricabile() {
        return this.exaDocumento && this.exaDocumento.idDocumento > 0 && (this.exaDocumento.stato == ExaDocumentoStato.caricato);
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
        if (this.selectedFiles.length > 0) {
            this.fileSelected.emit(this.selectedFiles[0]);
            if (this.uploadType == ExaFileUploadType.auto)
                this.upload();
        }

    }

    upload() {
        // TO BE IMPLEMENTED
    }

    getErrorMessage(err: any): string {
        if (err instanceof HttpErrorResponse) {
            switch (err.status) {
                case 413: //PAYLOAD TOO LARGE
                    return "Impossibile caricare il file: dimensione eccessiva";
                case 415: //Unsupported Media Type
                    return "Impossibile caricare il file: tipo file non supportato";
                default:
                    console.log(err);
                    return "Impossibile caricare il file";
            }
        }
        else {
            console.log(err);
            return 'Impossibile caricare il file';
        }
    }

    abort() {
        this.downloadAlive = false;
        this.currentFileUpload = null;
        this.selectedFiles = null;
        //ripristino lo stato caricato perchè l'upload è stato abortito ed il file predecende è ancora valido
        this.exaDocumento.stato = ExaDocumentoStato.caricato;
        this.stato=ExaControlStato.ok;

        this.onChange(this.exaDocumento);

    }
    // Function to call when the idDocumento changes.
    onChange = (doc: ExaDocumento) => { };

    // Function to call when the input is touched (when a document is selected).
    onTouched = () => { };


    writeValue(doc: ExaDocumento): void {
        //console.log('writeValue '+doc.idDocumento);
        this.exaDocumento = doc;

        if (this.inputField && this.exaDocumento && this.exaDocumento.idDocumento == null)
            this.inputField.nativeElement.value = "";
    }


    // Allows Angular to register a function to call when the model (idDocumento) changes.
    // Save the function as a property to call later here.
    registerOnChange(fn: (doc: ExaDocumento) => void): void {
        console.log('registerOnChange');
        this.onChange = fn;
    }

    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    registerOnTouched(fn: () => void): void {
        console.log('registerOnTouched');
        this.onTouched = fn;
    }


    // Allows Angular to disable the input.
    setDisabledState(isDisabled: boolean): void {
        console.log('setDisabledState');
        this.disabled = isDisabled;
    }

}

export enum ExaFileUploadType {
    auto = 0,
    manual = 1,
    external = 2,
    none = 3,
}


// WEBPACK FOOTER //
// ./src/app/exa/exa-file/exa-file.component.ts